import { lazy, Suspense } from "react";
import Body from "./components/Body";

import "@fontsource/poppins";
import "@fontsource/great-vibes";
import "./App.css";

const Highlights = lazy(() => import("./components/Highlights"));
const Footer = lazy(() => import("./components/Footer"));

function App() {

  return (
    <>
      <Body />
      <Suspense fallback={null}>
        <Highlights />
        <Footer />
      </Suspense>
    </>
  );
}

export default App;
